import "./frappe/provide.js";
import "./frappe/translate.js";
import "./frappe/class.js";
import "./frappe/polyfill.js";
import "./frappe/assets.js";
import "./frappe/format.js";
import "./frappe/form/formatters.js";
import "./frappe/dom.js";
import "./frappe/ui/messages.js";

import "./frappe/ui/components/button.js";
import "./frappe/ui/components/badge.js";
import "./frappe/ui/components/skeleton.js";
import "./frappe/ui/components/divider.js";
import "./frappe/ui/components/avatar.js";
import "./frappe/ui/components/alert.js";
import "./frappe/ui/components/breadcrumbs.js";
import "./frappe/ui/components/toast.js";
import "./frappe/ui/components/dropdown.js";
import "./frappe/ui/components/context_menu.js";
import "./frappe/ui/components/tooltip.js";
import "./frappe/ui/components/popover.js";
import "./frappe/ui/components/hover_card.js";
import "./frappe/ui/components/tabs.js";
import "./frappe/ui/components/tab_buttons.js";
import "./frappe/ui/components/progress.js";
import "./frappe/ui/components/empty_state.js";

import "./frappe/ui/background_tasks/background_tasks.js";
import "./frappe/ui/keyboard.js";
import "./frappe/ui/colors.js";
import "./frappe/ui/sidebar/sidebar_header.js";
import "./frappe/ui/sidebar/sidebar_header.html";
import "./frappe/ui/sidebar/dock_manager.js";
import "./frappe/ui/sidebar/sidebar.html";
import "./frappe/ui/sidebar/sidebar_item.html";
import "./frappe/ui/sidebar/sidebar.js";
import "./frappe/ui/sidebar/card.html";
import "./frappe/ui/sidebar/card.js";
import "./frappe/ui/link_preview.js";
import "./frappe/ui/list_dashboard.js"; // @dokos

import "./frappe/request.js";
import "./frappe/socketio_client.js";
import "./frappe/broadcast.js";
import "./frappe/utils/utils.js";
import "./frappe/event_emitter.js";
import "./frappe/router.js";
import "./frappe/router_history.js";
import "./frappe/defaults.js";
import "./frappe/roles_editor.js";
import "./frappe/module_editor.js";
import "./frappe/microtemplate.js";

import "./frappe/ui/site_banners.js";
import "./frappe/ui/page.html";
import "./frappe/ui/page.js";
import "./frappe/ui/slides.js";
import "./frappe/ui/find.js";
import "./frappe/ui/iconbar.js";
import "./frappe/form/layout.js";
import "./frappe/form/section.js";
import "./frappe/form/tab.js";
import "./frappe/form/column.js";
import "./frappe/ui/field_group.js";
import "./frappe/form/link_selector.js";
import "./frappe/form/multi_select_dialog.js";
import "./frappe/form/multi_options_dialog.js"; // @dokos
import "./frappe/ui/dialog.js";
import "./frappe/ui/settings_dialog.js";
import "./frappe/ui/menu.js";
import "./frappe/ui/capture.js";
import "./frappe/ui/permission_dialog.js";
import "./frappe/ui/app_icon.js";
import "./frappe/ui/theme_switcher.js";
import "./frappe/ui/naming_series.js";

import "./frappe/model/model.js";
import "./frappe/db.js";
import "./frappe/model/meta.js";
import "./frappe/model/sync.js";
import "./frappe/model/create_new.js";
import "./frappe/model/perm.js";
import "./frappe/model/workflow.js";
import "./frappe/model/user_settings.js";

import "./frappe/utils/user.js";
import "./frappe/utils/common.js";
import "./frappe/utils/urllib.js";
import "./frappe/utils/pretty_date.js";
import "./frappe/utils/tools.js";
import "./frappe/utils/datetime.js";
import "./frappe/utils/number_format.js";
import "./frappe/utils/help.js";
import "./frappe/utils/help_links.js";
import "./frappe/utils/address_and_contact.js";
import "./frappe/utils/preview_email.js";
import "./frappe/utils/file_manager.js";
import "./frappe/utils/diffview";
import "./frappe/utils/datatable.js";

import "./frappe/upload.js";
import "./frappe/ui/tree.js";

import "./frappe/views/container.js";
import "./frappe/views/breadcrumbs.js";
import "./frappe/views/factory.js";
import "./frappe/views/pageview.js";

import "./frappe/ui/toolbar/awesome_bar.js";
import "./frappe/ui/notifications/notifications.js";
import "./frappe/ui/toolbar/search.js";
import "./frappe/ui/toolbar/tag_utils.js";
import "./frappe/ui/toolbar/search.html";
import "./frappe/ui/toolbar/search_utils.js";
import "./frappe/ui/toolbar/about.js";
import "./frappe/ui/toolbar/navbar.html";
import "./frappe/ui/toolbar/toolbar.js";
import "./frappe/views/communication.js";
import "./frappe/views/translation_manager.js";
import "./frappe/views/workspace/workspace.js";
import "./frappe/views/workspace/blocks/index.js";

import "./frappe/widgets/widget_group.js";

import "./frappe/ui/sort_selector.html";
import "./frappe/ui/sort_selector.js";

import "./frappe/change_log.html";
import "./frappe/ui/workspace_loading_skeleton.html";
import "./frappe/ui/workspace_sidebar_loading_skeleton.html";
import "./frappe/legacy_gravatar_cleanup.js";
import "./frappe/desk.js";
import "./frappe/query_string.js";
import "./frappe/ui/card_group.js"; // @dokos: TODO: move or deprecate this

import "./frappe/utils/dashboard_utils.js";
import "./frappe/ui/chart.js";
import "./frappe/ui/datatable.js";
import "./frappe/ui/driver.js";
import "./frappe/scanner";

import "./frappe/utils/web_template.js"; // @dokos: TODO: move or deprecate this
import "./frappe/ui/address_autocomplete/autocomplete_dialog.js";
import "./frappe/ui/desktop_icon.html";
import "./frappe/ui/user_onboarding/user_onboarding.bundle.js";

import "./frappe/ui/document_timeline.js"; // @dokos
import "./frappe/ui/dynamic_links_cards.js"; // @dokos
import "./frappe/ui/desktop/launchpad.js"; // @dokos
